import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { ConfigService } from './../config/config.service';
import { NgxToastrService } from '../ngx-toastr/ngx-toastr.service';
import { ReporteriaService } from '../http/reporteria/reporteria.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "angular-user-idle";
import * as i2 from "../ngx-toastr/ngx-toastr.service";
import * as i3 from "../http/reporteria/reporteria.service";
import * as i4 from "@angular/router";
import * as i5 from "@angular/common/http";
import * as i6 from "../config/config.service";
export class AuthService {
    constructor(userIdle, ngxToastrService, reporteriaService, router, httpClient, config) {
        this.userIdle = userIdle;
        this.ngxToastrService = ngxToastrService;
        this.reporteriaService = reporteriaService;
        this.router = router;
        this.httpClient = httpClient;
        this.config = config;
        this.subscriptions = [];
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }
    login(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Auth/AutenticarCliente`;
            const rutCliente = parseInt(data['rutCliente'], 10);
            const auth = { rutCliente, clave: data['clave'] };
            try {
                return yield this.httpClient.post(url, auth, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    parametrosTotem() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['totem']}/TotemInfo`;
            try {
                return yield this.httpClient.get(url, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    envioClaveCliente(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Auth/EnvioClaveCliente`;
            const rut = parseInt(data['rut'], 10);
            const opcionEnvio = parseInt(data['opcionEnvio'], 10);
            const userData = { rut, opcionEnvio };
            try {
                return yield this.httpClient.post(url, userData, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    cambiarClave(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Auth/CambioClave`;
            const rutCliente = parseInt(data['rutCliente'], 10);
            const userData = { rutCliente, clave: data['clave'] };
            try {
                return yield this.httpClient.post(url, userData, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    obtenerClave(rut) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Auth/ObtenerOpcionesRecuperacionClave?rut=${rut}`;
            try {
                return yield this.httpClient.get(url).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    leerCliente(rut) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/Auth/LeerCliente?rut=${rut}`;
            try {
                const response = yield this.httpClient.get(url).toPromise();
                const status = response['status'];
                if (status) {
                    const userInfo = response['data'];
                    this.setSession(userInfo['datosCliente'], 'leerCliente');
                    return response;
                }
                else {
                    const errorMessage = response['message'];
                    return response;
                }
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    isLogged() {
        if (localStorage.getItem('login') === 'true') {
            return true;
        }
        else {
            return false;
        }
    }
    setSession(data, metodo) {
        if (metodo === 'login') {
            localStorage.setItem('cbLogin', 'true');
            localStorage.setItem('cbRutCliente', data['rutCliente']);
        }
        else {
            localStorage.setItem('cbRutCliente', data['rutCliente']);
            localStorage.setItem('cbDigRut', data['digRut']);
            localStorage.setItem('cbNombre', data['nombre']);
            localStorage.setItem('cbApeliidoPaterno', data['apellidoPaterno']);
            localStorage.setItem('cbApeliidoMaterno', data['apellidoMaterno']);
        }
    }
    logout() {
        localStorage.clear();
        this.router.navigate(['']);
    }
    idleUser() {
        this.userIdle.startWatching();
        this.subscriptions.push(this.userIdle.onTimerStart().subscribe(count => {
            const eventList = [
                'click', 'mouseover', 'keydown', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'keyup'
            ];
            eventList.map((event => {
                document.body.addEventListener(event, () => this.userIdle.resetTimer());
            }));
        }));
        this.subscriptions.push(this.userIdle.onTimeout().subscribe(() => {
            if (this.router.url !== '/') {
                this.userIdle.resetTimer();
                this.userIdle.stopTimer();
                this.userIdle.stopWatching();
                this.subscriptions.forEach(subscription => subscription.unsubscribe());
                this.ngxToastrService.error('Su sesión ha caducado por inactividad');
                this.reporteUsabilidad('Tótem', 'Cierre de sesión por inactividad', true);
                this.logout();
            }
        }));
    }
    reporteUsabilidad(recurso, respuesta, status) {
        if (localStorage.getItem('cbRutCliente') !== null) {
            const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');
            this.reporteriaService.saveLog('Tótem', recurso, respuesta, 'Front-End', status, rut);
        }
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.UserIdleService), i0.ɵɵinject(i2.NgxToastrService), i0.ɵɵinject(i3.ReporteriaService), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i5.HttpClient), i0.ɵɵinject(i6.ConfigService)); }, token: AuthService, providedIn: "root" });
